import { useLocale } from '@b2c/hooks';
import classNames from 'classnames';
import { FormattedMessage } from 'react-intl';
import { Link } from 'react-router-dom';
import { Button, Typography } from 'react-vant';
import { Panel } from '../panel';
import styles from './user-login-guide.module.less';

export function UserLoginGuide(
  props: {
    // onBtnClick(): void;
    scene?: 'fillin' | 'confirm' | 'result';
  } & React.DetailedHTMLProps<
    React.HTMLAttributes<HTMLDivElement>,
    HTMLDivElement
  >
) {
  const t = useLocale();
  let content = null;
  const { className, ...rest } = props;

  const loginUrl = `/account/login?returnUrl=${encodeURIComponent(
    window.location.href
  )}`;

  switch (props.scene) {
    case 'fillin':
      content = (
        <div className={styles.content}>
          <FormattedMessage
            id="Text_LoginGuide_OrderFillin"
            values={{
              a: (chunk) => (
                <Typography.Link underline href={loginUrl}>
                  {chunk}
                </Typography.Link>
              ),
            }}
          ></FormattedMessage>
        </div>
      );
      break;
    case 'result':
      content = (
        <div className={styles.content}>
          <FormattedMessage
            id="Text_LoginGuide_OrderResult"
            values={{
              a: (chunk) => (
                <Typography.Link underline href={loginUrl}>
                  {chunk}
                </Typography.Link>
              ),
            }}
          ></FormattedMessage>
        </div>
      );
      break;
    default:
      content = (
        <>
          <div className={styles.content}>{t('Text_LoginGuide_HotelList')}</div>
          <div className={styles.btn}>
            <Link to={loginUrl}>
              <Button
                type="primary"
                className="mu-search-button mu-search-button_shadowless"
                size="small"
              >
                {t('Button_BecomeMember')}
              </Button>
            </Link>
          </div>
        </>
      );
  }
  return (
    <Panel
      inset
      shadowless
      className={classNames(className, styles.loginGuide)}
    >
      <div className={styles.inner} {...rest}>
        <img
          className={styles.img}
          src="/assets/images/login-guide-tag.webp"
          alt=""
        />
        <div>{content}</div>
      </div>
    </Panel>
  );
}
